export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9753.34a6694c.jpg";